<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout"
                               active
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="support()">
                               Support
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="faq()">
                               FAQ
    </b-nav-item>
    </b-nav>
    </div>
    <div class = "profile-div col-12">
      <h5 class="mt-3 mb-3"> People Counter </h5>
    </div>
  <div class="main-div">
    <b-card-group deck class="mb-3">
      <b-card class="text-center card-background"
      @mouseover="activeLink='userGuide'"
      @mouseleave="activeLink=null">
          <a
            @click="sale()"
            class="link-decoration link-color-settings flex-container"
            :class="{'link-color-menu': activeLink === 'userGuide'}">
          <div class="mt-30"> <v-icon name="package" base-class="icon-width"></v-icon> </div>
          <div class="mt-3"> User Guide</div>
        </a>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='downloads'"
      @mouseleave="activeLink=null">
        <a @click="downloads()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'downloads'}">
          <div class="mt-30"> <v-icon name="file" base-class="icon-width"></v-icon> </div>
          <div class="mt-3"> Downloads</div>
        </a>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='orderNow'"
      @mouseleave="activeLink=null">
        <a @click="orderNow()" class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'orderNow'}">
        <div class="mt-30"> <v-icon name="shopping-cart" base-class="icon-width"></v-icon> </div>
        <div class = "mt-3" > Order Now</div>
      </a>
      </b-card>
    </b-card-group>
</div>
<!-- <div class = "profile-div col-12">
  <h5 class="mt-5"> People Counting Webinar - 9th July 2020 </h5><br>
  <div class="wdiv">
    <b-embed
      type="iframe"
      aspect="16by9"
      src="https://www.youtube.com/embed/TT5sAOyvEKY"
    ></b-embed><br>
  </div>
</div> -->
</div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';

export default {
  name: 'peoplecounting',
  components: { FacitHeader },
  data() {
    return {
      credit: null,
      activeLink: null,
      AccountDetail: null,
    };
  },
  methods: {
    dashboard() {
      this.$router.push('peoplecounting');
    },
    downloads() {
      this.$router.push('facitDownloads');
    },
    demo() {
      window.location = 'https://server.facitdatasystems.com';
    },
    videos() {
      this.$router.push('videos');
    },
    sale() {
      this.$router.push('userGuide');
    },
    architecture() {
      this.$router.push('architecture');
    },
    hardwareCalculator() {
      this.$router.push('hardwareCalculator');
    },
    support() {
      this.$router.push('facitSupport');
    },
    faq() {
      this.$router.push('faq');
    },
    orderNow() {
      this.$router.push('orderNow');
    },
    identityCloak() {
      this.$router.push('identityCloak');
    },
    licence() {
      this.$router.push('licence');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
  text-align: center;
}
.logout {
  margin-top: 28px;
}
.mt-30 {
  margin-top: 30px;
}

.mt-11 {
  margin-top: 11px;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
  min-width: 100%;
  width: 100%;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
  width: 70%;
}
.logo2 {
  margin-top: 20px;
  margin-left: 30px;
  width: 55%;
}
.main-div {
  width: 80%;
  margin: 30px auto;
}
.card-background {
  background-color: #DCDCDC;
  height: 225px;
  text-align: center;
  border: 1px solid #eee;
}

.icon-width {
  width: 40px !important;
  height: 40px !important;
}
.buy-credits-button {
  float: left;
}

.flex-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.icon-div {
  margin-top: 30px;
}

.link-decoration {
  text-decoration: none;
  cursor: pointer;
}

a {
  color: #656580 !important
}

.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.link-color-hover {
  color: #fff;
}
.link-color-menu {
  color: #9da7b2 !important;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.active {
  color: #ff8f00 !important;
}
.nav-link-custom {
    background: white;
    border: #fe5623;
    color: #656580 !important;
}
li > a > span{
  color: #656580 !important;
}
.bottom-right {
    position: absolute;
    bottom: 10px;
    right: 0px;
}
.wdiv {
  width: 500px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/peoplecounter.vue